import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ac-type-4-icon',
  templateUrl: './ac-type-4-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AcType4IconComponent {}
